import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

const AuthCheck = (props) => {
  const [timer, setTimer] = useState(new Date().getTime());
  const history = useHistory();

  useEffect(() => {
    setInterval(() => {
      setTimer((prev) => prev + 1000);
    }, 1000);
  }, []);

  useEffect(() => {
    if (!!props.authData) {
      // const localTime = (new Date().getTimezoneOffset() / -60) * 60 * 60 * 1000;
      // const expTime = props.authData.result.expires * 1000 + localTime;
      // const expTime = props.authData.result.expires * 1000;
      const expTime = !!props.authData.result && !!props.authData.result.expires ? props.authData.result.expires : 0;
      // console.log(expTime, timer, expTime - timer);
      if (expTime - timer <= 0) {
        history.push("/logout")
      }
    }
  }, [props.authData, timer, history]);
  return <>{props.children}</>;
};

const mapStateToProps = (state) => {
  return {
    authData: state.authStore.authData,
  };
};

export default connect(mapStateToProps, {})(AuthCheck);
